import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import MyManagementDash from '../Projectmanager/MyManagement/MyManagementDash'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllProjects } from '../../../store/slices/projectsSlice'
import { fetchLeads } from '../../../store/slices/leadsSlice'
import { isProjectLinkedToLostLead } from '../../../utils/syncLeadProjectBucketStatus'
import { fetchWorkEntriesProjectTracking } from '../../../store/slices/workentriesSlice'
import { fetchEmployees } from '../../../store/slices/employeeAdminSlice'
import MyTraining from '../../MyTraining/MyTraining'
import TimeEntriesGraph from '../OperationFeatures/TimeEntriesGraph'
import TaskInHand from '../OperationFeatures/TaskInHand'
import UtilizationReport from '../OperationFeatures/UtilizationReport'
import ProjectRequestedOP from '../Operationperson/ProjectRequestedOP/ProjectRequestedOP'
import ProjectApprovedDash from '../Operationperson/ProjectApprovedOP/ProjectApprovedDash'
import ProjectOngoingOPDash from '../Operationperson/ProjectOngoingOP/ProjectOngoingOPDash'
import ProjectCompletedOpDash from '../Operationperson/ProjectCompletedOP/ProjectCompletedOpDash'
import ManagerAssignSelf from '../Projectmanager/MyManagement/ManagerAssignAssignment.jsx/ManagerAssignSelf'
import SpeedometerGraph from '../OperationFeatures/SpeedometerGraph'
import ManagerMyProjects from '../Projectmanager/ManagerMyProjects'
import { hasViewOrFullAccess, getFeatureAccessLevel } from '../../../utils/featureAccessUtils'

const MyManagementParent = ({ filteredOngoingEntries, filteredOngoingProjects, filteredOngoingHardwareParts, selectedEmp }) => {
  const dispatch = useDispatch();

  const { projects } = useSelector((state) => state.projects);
  const { leads } = useSelector((state) => state.leads);
  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { employees } = useSelector((state) => state.employees);
  const [ongoingProjectsManager, setOngoingProjectsManager] = useState([]);
  const [completeProjectsManager, setCompleteProjectsManager] = useState([]);
  const [ongoingEntries, setongoingEntries] = useState([]);
  const [projectsRequest, setProjectsRequest] = useState([]);
  const [approvedProjectsManager, setApprovedProjectsManager] = useState([]);
  const [assignedOpProjects, setAssignedOpProjects] = useState([]);

  const [selectedTabState, setselectedTabState] = useState([]);
  const [selectedTabprojectrequest, setselectedTabprojectrequest] = useState(false);
  const [selectedTabprojectapproved, setselectedTabprojectapproved] = useState(false);
  const [selectedTabprojectassign, setselectedTabprojectassign] = useState(false);
  const [selectedTabprojectongoing, setselectedTabprojectongoing] = useState(false);
  const [selectedTabprojectcomplete, setselectedTabprojectcomplete] = useState(false);

  const [unreadcount, setunreadcount] = useState([]);
  const [unreadcountapproved, setunreadcountapproved] = useState([]);
  const [unreadcountAssign, setunreadcountAssign] = useState([]);
  const [unreadcountongoing, seunreadcountongoing] = useState([]);
  const [unreadcountcomplete, setunreadcountcomplete] = useState([]);
  const [currentEmployee, setcurrentEmployee] = useState();
  const [loggedEmp, setLoggedEmp] = useState({});
  const email = localStorage.getItem("email")

  // Task click selection comes from Redux in TaskInHand / UtilizationReport.
  // My Management (ManagerAssignment) opens the correct bucket by listening to this Redux state;
  // My Assignments was missing that sync, so we replicate it here.
  const reduxSelectedTabState = useSelector(
    (state) => state.operationState.selectedTabState
  );
  const reduxSelectedProjectName = useSelector(
    (state) => state.taskScroll.selectedProjectName
  );
  const reduxSelectedTaskId = useSelector(
    (state) => state.taskScroll.selectedTaskId
  );

  useEffect(() => {
    const employee = employees.find((emp) => emp.EmpEmail === email);
    console.log("fsgsdg", employee)
    setcurrentEmployee(employee)
  }, [email, employees]);

  const hasNoFeatureConfig = !currentEmployee?.featureAccess || currentEmployee.featureAccess.length === 0;

  const canShowCard = (featureName) => {
    if (hasNoFeatureConfig) return true;
    if (hasViewOrFullAccess(currentEmployee, featureName)) return true;
    if (!getFeatureAccessLevel(currentEmployee, featureName)) {
      return hasViewOrFullAccess(currentEmployee, "MY ASSIGNEMENT") ||
             hasViewOrFullAccess(currentEmployee, "MY ASSIGNMENT");
    }
    return false;
  };

  const taskInHandAccessLevel = getFeatureAccessLevel(currentEmployee, "TASK IN HAND");
  const isViewOnlyTaskInHand = !hasNoFeatureConfig && taskInHandAccessLevel && String(taskInHandAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const utilizationAccessLevel = getFeatureAccessLevel(currentEmployee, "UTILISATION REPORT");
  const isViewOnlyUtilization = !hasNoFeatureConfig && utilizationAccessLevel && String(utilizationAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const myRequestAccessLevel = getFeatureAccessLevel(currentEmployee, "MY REQUEST");
  const isViewOnlyMyRequests = !hasNoFeatureConfig && myRequestAccessLevel && String(myRequestAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  console.log("MyManagementParent Access Level - TASK IN HAND:", taskInHandAccessLevel, "isViewOnly:", isViewOnlyTaskInHand);
  console.log("MyManagementParent Access Level - UTILISATION REPORT:", utilizationAccessLevel, "isViewOnly:", isViewOnlyUtilization);

  // Check if logged-in manager is a hardware manager
  const isHardwareManager = currentEmployee?.servicetype?.toLowerCase() === "hardware";
  // Check if selected employee is a hardware employee
  const isSelectedHardwareEmployee = selectedEmp?.servicetype?.toLowerCase() === "hardware";
  // Determine if we should show hardware employee layout:
  // - If manager is hardware (viewing their own dashboard), OR
  // - If selected employee is a hardware employee
  const showHardwareLayout = isHardwareManager || isSelectedHardwareEmployee;

  useEffect(() => {
    dispatch(fetchAllProjects());
    dispatch(fetchLeads());
    dispatch(fetchEmployees());
    dispatch(fetchWorkEntriesProjectTracking());
  }, [dispatch]);

  const handlerefresh = async () => {
    await dispatch(fetchAllProjects());
  }

  const OpProjectRequest = useRef(null);
  const OpProjectAssigned = useRef(null);
  const OpProjectOngoing = useRef(null);
  const OpProjectCompleted = useRef(null);
  const OpProjectApproved = useRef(null);

  const LoggedUser = localStorage.getItem("email");

  const refsMap = useMemo(
    () => ({
      projectRequest: OpProjectRequest,
      projectAssigned: OpProjectAssigned,
      projectOngoing: OpProjectOngoing,
      projectCompleted: OpProjectCompleted,
      projectApproved: OpProjectApproved,
    }),
    []
  );

  useLayoutEffect(() => {
    const node = refsMap[selectedTabState]?.current;
    if (node) {
      node.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [selectedTabState, refsMap]);

  // Reuse "My Management" working logic:
  // Whenever a task is clicked (TaskInHand / UtilizationReport), Redux sets
  // selectedTabState="projectOngoing" + selectedTaskId/selectedProjectName.
  // We must override local My Assignments bucket state to open Project Ongoing
  // even if another bucket (Approved/Assigned/Completed) was active.
  useEffect(() => {
    if (reduxSelectedTabState !== "projectOngoing") return;

    setselectedTabState("projectOngoing");
    setselectedTabprojectrequest(false);
    setselectedTabprojectapproved(false);
    setselectedTabprojectassign(false);
    setselectedTabprojectongoing(true);
    setselectedTabprojectcomplete(false);
  }, [
    reduxSelectedTabState,
    reduxSelectedProjectName,
    reduxSelectedTaskId,
  ]);

  // Single effect: compute all My Requests derived lists from projects + LoggedUser only.
  // Prevents cascade of effects that caused flickering (each effect was depending on others' state).
  useEffect(() => {
    if (!Array.isArray(projects) || !LoggedUser) return;

    const getQuotationId = (p) => p?.quotationId ?? p?.QuotationId ?? null;
    const projectMatches = (project, requestProject) => {
      const qId1 = getQuotationId(project);
      const qId2 = getQuotationId(requestProject);
      if (qId1 != null && qId2 != null) return String(qId1) === String(qId2);
      return project.ProjectName === requestProject.ProjectName && project.TypeService === requestProject.TypeService;
    };
    const isInList = (requestProject, list) => list?.some((project) => projectMatches(project, requestProject));

    const completeOp = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some((person) => person.operationstatus === "project complete") &&
        !isProjectLinkedToLostLead(proj, leads)
    ).filter((proj) =>
      proj.Assignedperson?.some((person) => person.email?.toLowerCase() === LoggedUser.toLowerCase())
    );
    const ongoingManager = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some((person) => person.managerstatus === "project ongoing") &&
        !isProjectLinkedToLostLead(proj, leads)
    ).filter((proj) =>
      proj.Assignedperson?.some((person) => person.email?.toLowerCase() === LoggedUser.toLowerCase())
    );
    const completeManager = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some((person) => person.managerstatus === "project complete") &&
        !isProjectLinkedToLostLead(proj, leads)
    ).filter((proj) =>
      proj.Assignedperson?.some((person) => person.email?.toLowerCase() === LoggedUser.toLowerCase())
    );

    const rawApproved = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some((person) => person.managerstatus === "project approved") &&
        !isProjectLinkedToLostLead(proj, leads)
    ).filter((proj) =>
      proj.Assignedperson?.some((person) => person.email?.toLowerCase() === LoggedUser.toLowerCase())
    );
    const rawAssigned = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some((person) => person.managerstatus === "project assigned") &&
        !isProjectLinkedToLostLead(proj, leads)
    );

    const approvedProjectsManagerNext = rawApproved.filter(
      (requestProject) =>
        !isInList(requestProject, rawAssigned) && !isInList(requestProject, ongoingManager) && !isInList(requestProject, completeOp) && !isInList(requestProject, completeManager)
    );
    const managerAssignedFiltered = rawAssigned.filter(
      (requestProject) =>
        !isInList(requestProject, approvedProjectsManagerNext) && !isInList(requestProject, ongoingManager) && !isInList(requestProject, completeOp) && !isInList(requestProject, completeManager)
    );
    const assignedOpProjectsNext = managerAssignedFiltered.filter((proj) =>
      proj.Assignedperson?.some((person) => person.email?.toLowerCase() === LoggedUser.toLowerCase())
    );

    const name = localStorage.getItem("name");
    const lastName = localStorage.getItem("lastName");
    const AssignPerson = `${name} ${lastName}`;
    const rawRequest = projects.filter(
      (project) =>
        project.ProjectManagerStatus === "project requested" &&
        Array.isArray(project.Assignedperson) &&
        project.Assignedperson.some((person) => person.name?.toLowerCase() === AssignPerson.toLowerCase()) &&
        !isProjectLinkedToLostLead(project, leads)
    );
    const projectsRequestNext = rawRequest?.filter(
      (requestProject) =>
        !isInList(requestProject, approvedProjectsManagerNext) &&
        !isInList(requestProject, assignedOpProjectsNext) &&
        !isInList(requestProject, ongoingManager) &&
        !isInList(requestProject, completeOp) &&
        !isInList(requestProject, completeManager)
    );

    setOngoingProjectsManager(ongoingManager);
    setCompleteProjectsManager(completeManager);
    setApprovedProjectsManager(Array.isArray(approvedProjectsManagerNext) ? approvedProjectsManagerNext : []);
    setAssignedOpProjects(assignedOpProjectsNext);
    setProjectsRequest(Array.isArray(projectsRequestNext) ? projectsRequestNext : []);
  }, [projects, LoggedUser, leads]);

  useEffect(() => {
    if (projectTrackingWorkEntries?.length && ongoingProjectsManager?.length) {
      const ongoingProjectIds = ongoingProjectsManager.map(project => project?._id);
      const filtered = projectTrackingWorkEntries.filter((entry) => {
        const matchesProject = ongoingProjectIds.includes(entry.projectid);
        return matchesProject;
      });
      const managerEntries = filtered.filter((entry) => entry.taskownerid === loggedEmp?._id)
      setongoingEntries(managerEntries);
    } else {
      setongoingEntries([]);
    }
  }, [projectTrackingWorkEntries, ongoingProjectsManager, loggedEmp]);

  useEffect(() => {
    const Email = localStorage.getItem('email');
    const emp = employees?.find((e) => e?.EmpEmail === Email);
    setLoggedEmp(emp);
  }, [employees]);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email"); // Replace with actual logged-in email
    const filteredLeads = projectsRequest.filter(project => {
      if (!project.Assignedperson || !Array.isArray(project.Assignedperson)) {
        return false;
      }
      const userAssignment = project.Assignedperson.find(person =>
        person.email === loggedInUserEmail && person.isRead === false
      );
      return userAssignment !== undefined;
    });
    setunreadcount(filteredLeads)
  }, [projectsRequest]);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email"); // Replace with actual logged-in email
    const filteredLeads = assignedOpProjects.filter(project => {
      if (!project.Assignedperson || !Array.isArray(project.Assignedperson)) {
        return false;
      }
      const userAssignment = project.Assignedperson.find(person =>
        person.email === loggedInUserEmail && person.isRead === false
      );
      return userAssignment !== undefined;
    });
    setunreadcountAssign(filteredLeads)
  }, [assignedOpProjects]);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email"); // Replace with actual logged-in email

    const filteredLeads = ongoingProjectsManager.filter(project => {
      if (!project.Assignedperson || !Array.isArray(project.Assignedperson)) {
        return false;
      }
      const userAssignment = project.Assignedperson.find(person =>
        person.email === loggedInUserEmail && person.isRead === false
      );

      return userAssignment !== undefined;
    });
    seunreadcountongoing(filteredLeads)
  }, [ongoingProjectsManager]);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email"); // Replace with actual logged-in email
    const filteredLeads = completeProjectsManager.filter(project => {
      if (!project.Assignedperson || !Array.isArray(project.Assignedperson)) {
        return false;
      }
      const userAssignment = project.Assignedperson.find(person =>
        person.email === loggedInUserEmail && person.isRead === false
      );
      return userAssignment !== undefined;
    });
    setunreadcountcomplete(filteredLeads)
  }, [completeProjectsManager]);

  useEffect(() => {
    const loggedInUserEmail = localStorage.getItem("email"); // Replace with actual logged-in email
    const filteredLeads = approvedProjectsManager.filter(project => {
      // Check if Assignedperson array exists and has items
      if (!project.Assignedperson || !Array.isArray(project.Assignedperson)) {
        return false;
      }
      const userAssignment = project.Assignedperson.find(person =>
        person.email === loggedInUserEmail && person.isRead === false
      );
      return userAssignment !== undefined;
    });
    setunreadcountapproved(filteredLeads)
  }, [approvedProjectsManager]);

  return (
    <div className=''>
      <div className={`w-full flex ${showHardwareLayout ? "gap-5" : "gap-1"} min-h-[20rem] justify-center pb-0.1 mt-1`}>
        {showHardwareLayout && canShowCard("MY PROJECTS") && (
          <div className="border-gray-400 w-[33%]">
            <ManagerMyProjects
              ongoingProjectsManager={ongoingProjectsManager}
              ongoingEntries={ongoingEntries}
            />
          </div>
        )}
        {!showHardwareLayout && (canShowCard("MY PROJECTS") || canShowCard("APPROVED HRS")) && (
          <div className={`border-gray-400 ${(canShowCard("MY PROJECTS") && !canShowCard("APPROVED HRS")) ? "w-[25%]" :
            (!canShowCard("MY PROJECTS") && canShowCard("APPROVED HRS")) ? "w-[25%]" :
              (canShowCard("MY PROJECTS") && canShowCard("APPROVED HRS")) ? "w-[50%]" : ""}`}>
            <ManagerMyProjects
              ongoingProjectsManager={ongoingProjectsManager}
              ongoingEntries={ongoingEntries}
            />
          </div>
        )}
        {canShowCard("PRODUCTIVITY") && (
          <div className={`border-gray-400 ${showHardwareLayout ? "w-[33%]" : "w-[25%] xl:w-[25%]"}`}>
            <SpeedometerGraph
              ongoingEntries={filteredOngoingEntries} />
          </div>
        )}
        {showHardwareLayout && canShowCard("MY REQUEST") && (
          <div className="w-[33%] relative z-10">
            <MyManagementDash
              selectedTabprojectrequest={selectedTabprojectrequest}
              selectedTabprojectapproved={selectedTabprojectapproved}
              selectedTabprojectassign={selectedTabprojectassign}
              selectedTabprojectongoing={selectedTabprojectongoing}
              selectedTabprojectcomplete={selectedTabprojectcomplete}
              setselectedTabState={setselectedTabState}
              setselectedTabprojectrequest={setselectedTabprojectrequest}
              setselectedTabprojectapproved={setselectedTabprojectapproved}
              setselectedTabprojectassign={setselectedTabprojectassign}
              setselectedTabprojectongoing={setselectedTabprojectongoing}
              setselectedTabprojectcomplete={setselectedTabprojectcomplete}
              unreadcount={unreadcount}
              unreadcountapproved={unreadcountapproved}
              unreadcountAssign={unreadcountAssign}
              unreadcountongoing={unreadcountongoing}
              unreadcountcomplete={unreadcountcomplete}
              projectsRequest={projectsRequest}
              approvedProjectsManager={approvedProjectsManager}
              assignedOpProjects={assignedOpProjects}
              ongoingOpProjects={ongoingProjectsManager}
              completeOpProjects={completeProjectsManager}
            />
          </div>
        )}
        {!showHardwareLayout && canShowCard("PROJECTS & TIME ENTRIES") && (
          <div className="border-gray-400 w-[25%] xl:w-[25%]">
            <TimeEntriesGraph
              ongoingProjectsManager={filteredOngoingProjects}
              filteredOngoingEntries={filteredOngoingEntries}
            />
          </div>
        )}
      </div>

      {/* For non-hardware managers, show second row with MY REQUEST, TASK IN HAND, UTILISATION REPORT */}
      {!showHardwareLayout && (
        <div className="w-full flex gap-1 pt-2 min-h-[22rem] h-auto items-start">
        {canShowCard("MY REQUEST") && (
            <div className="border-gray-400 w-[40%] relative shrink-0">
            <MyManagementDash
              selectedTabprojectrequest={selectedTabprojectrequest}
              selectedTabprojectapproved={selectedTabprojectapproved}
              selectedTabprojectassign={selectedTabprojectassign}
              selectedTabprojectongoing={selectedTabprojectongoing}
              selectedTabprojectcomplete={selectedTabprojectcomplete}
              setselectedTabState={setselectedTabState}
              setselectedTabprojectrequest={setselectedTabprojectrequest}
              setselectedTabprojectapproved={setselectedTabprojectapproved}
              setselectedTabprojectassign={setselectedTabprojectassign}
              setselectedTabprojectongoing={setselectedTabprojectongoing}
              setselectedTabprojectcomplete={setselectedTabprojectcomplete}
              unreadcount={unreadcount}
              unreadcountapproved={unreadcountapproved}
              unreadcountAssign={unreadcountAssign}
              unreadcountongoing={unreadcountongoing}
              unreadcountcomplete={unreadcountcomplete}
              projectsRequest={projectsRequest}
              approvedProjectsManager={approvedProjectsManager}
              assignedOpProjects={assignedOpProjects}
              ongoingOpProjects={ongoingProjectsManager}
              completeOpProjects={completeProjectsManager}
            />
          </div>
        )}
        {canShowCard("TASK IN HAND") && (
          <div className="border-gray-400 w-[25%]">
            <TaskInHand
              ongoingEntries={filteredOngoingEntries}
              ongoingOpProjectsState={filteredOngoingProjects}
              ongoingHardwareParts={filteredOngoingHardwareParts}
              isViewOnly={isViewOnlyTaskInHand}
              isInteractionDisabled={isViewOnlyTaskInHand}
            />
          </div>
        )}
        {canShowCard("UTILISATION REPORT") && (
          <div className="border-gray-400 w-[35%]">
            <UtilizationReport
              ongoingProjectsManager={filteredOngoingProjects}
              ongoingEntries={filteredOngoingEntries}
              User={"Operations"}
              isViewOnly={isViewOnlyUtilization}
              isInteractionDisabled={isViewOnlyUtilization}
            />
          </div>
        )}
      </div>
      )}
      {/* For hardware managers, reduce top padding to bring tables upward while keeping spacing */}
      <div className={showHardwareLayout ? "pt-0.1" : ""}>
      <div>
        {selectedTabprojectrequest && (
          <div className="" ref={OpProjectRequest}>
            <ProjectRequestedOP
              filterRequestProjects={projectsRequest}
              handlerefresh={handlerefresh}
              isViewOnly={isViewOnlyMyRequests}
            />
          </div>
        )}

        {selectedTabprojectapproved && (
          <div className="pt-2" ref={OpProjectApproved}>
            <ProjectApprovedDash
              approvedOpProjectsState={approvedProjectsManager}
              handlerefresh={handlerefresh}
              isViewOnly={isViewOnlyMyRequests}
            />
          </div>
        )}
        {selectedTabprojectassign && (
          <div className="pt-2" ref={OpProjectAssigned}>
            <ManagerAssignSelf assignedProjectsManager={assignedOpProjects} isViewOnly={isViewOnlyMyRequests} />
          </div>
        )}

        {(selectedTabprojectongoing) && (
          <div className="pt-2" ref={OpProjectOngoing}>
            <ProjectOngoingOPDash
              ongoingOpProjects={ongoingProjectsManager}
              handlerefresh={handlerefresh}
              isViewOnly={isViewOnlyMyRequests}
            />
          </div>
        )}

        {selectedTabprojectcomplete && (
          <div ref={OpProjectCompleted}>
            <ProjectCompletedOpDash
              completeOpProjects={completeProjectsManager}
              handlerefresh={handlerefresh}
              isViewOnly={isViewOnlyMyRequests}
            />
          </div>
        )}
        </div>
      </div>

      {canShowCard("MY TRAININGS") && (
        <div className="w-full  gap-1 pt-2">
          {["L3", "L4"].includes(loggedEmp?.EmpAuthLevel) && (
            <div className="">
              <MyTraining />
            </div>
          )}

        </div>
      )}
    </div>
  )
}

export default MyManagementParent
